import { helper as buildHelper } from '@ember/component/helper';

export function getElementById([id]) {
  return document.getElementById(id);
}

export default buildHelper(getElementById);
